/**
 * What the console offers when it cannot open a document itself.
 *
 * The desktop app gained `MissingCollabEditorNotice`, which offers to install
 * the extension that owns a document type. A browser cannot install anything,
 * so the honest fallback is the handoff the console already uses for documents
 * that exceed its size ceiling: name what is missing, say nothing is lost, and
 * point at the app that can open it.
 */

import { BUTTON_PRIMARY_LG } from '../controlStyles';
import { EDITOR_NOTICE_ERROR } from './editorSurfaceStyles';

export interface DesktopHandoffPanelProps {
  /** Rendered as `data-docs-state`, so a test can name the case it is asserting. */
  state: 'unsupported-document-type' | 'editor-unavailable';
  title: string;
  /** The specific reason, from the catalog or the failed load. */
  detail?: string;
  desktopHref?: string;
}

export function DesktopHandoffPanel({
  state,
  title,
  detail,
  desktopHref,
}: DesktopHandoffPanelProps) {
  return (
    <div
      className={`docs-state-panel collab-editor-error collab-editor-desktop-fallback ${EDITOR_NOTICE_ERROR} [&>small]:text-nim-muted`}
      role="alert"
      data-docs-state={state}
    >
      <strong>{title}</strong>
      <span>
        Nothing is wrong with the document and nothing has been lost. A browser
        cannot install the editor this document needs; Nimbalyst desktop opens
        it normally.
      </span>
      {detail && <small>{detail}</small>}
      {desktopHref && <a className={`${BUTTON_PRIMARY_LG} mt-[0.4rem]`} href={desktopHref}>Open in Nimbalyst desktop</a>}
    </div>
  );
}
